import { getInitialResults } from "instantsearch.js/es/lib/server.js";
import { walkIndex } from "instantsearch.js/es/lib/utils/index.js";
import { ServerInsertedHTMLContext } from "next/navigation.js";
import React, { useContext } from 'react';
import { useInstantSearchContext, useRSCContext, wrapPromiseWithState } from 'react-instantsearch-core';
var _ref2 = /*#__PURE__*/React.createElement(React.Fragment, null);
export function InitializePromise() {
  var _search = useInstantSearchContext();
  var waitForResultsRef = useRSCContext();
  var insertHTML = useContext(ServerInsertedHTMLContext) || function () {
    throw new Error('Missing ServerInsertedHTMLContext');
  };

  // Extract search parameters from the search client to use them
  // later during hydration.
  var requestParamsList;
  _search.mainHelper.setClient({
    search: function search(queries) {
      requestParamsList = queries.map(function (_ref) {
        var params = _ref.params;
        return params;
      });
      return _search.client.search(queries);
    }
  });
  var waitForResults = function waitForResults() {
    return new Promise(function (resolve) {
      _search.mainHelper.derivedHelpers[0].on('result', function () {
        resolve();
      });
    });
  };
  var injectInitialResults = function injectInitialResults() {
    var inserted = false;
    var results = getInitialResults(_search.mainIndex, requestParamsList);
    insertHTML(function () {
      if (inserted) {
        return _ref2;
      }
      inserted = true;
      return /*#__PURE__*/React.createElement("script", {
        dangerouslySetInnerHTML: {
          __html: "window[Symbol.for(\"InstantSearchInitialResults\")] = ".concat(JSON.stringify(results))
        }
      });
    });
  };
  if ((waitForResultsRef === null || waitForResultsRef === void 0 ? void 0 : waitForResultsRef.current) === null) {
    waitForResultsRef.current = wrapPromiseWithState(waitForResults().then(function () {
      var shouldRefetch = false;
      walkIndex(_search.mainIndex, function (index) {
        shouldRefetch = index.getWidgets().some(function (widget) {
          return widget.$$type === 'ais.dynamicWidgets';
        });
      });
      if (shouldRefetch) {
        waitForResultsRef.current = wrapPromiseWithState(waitForResults().then(injectInitialResults));
      }
      return shouldRefetch;
    }).then(function (shouldRefetch) {
      if (shouldRefetch) {
        return;
      }
      injectInitialResults();
    }));
  }
  return null;
}